export const BankingRootStateConfigKeys = {
  BlocAuthApiUrl: 'blocAuthApiUrl',
  BlocBanksApiUrl: 'blocBanksApiUrl',
  BlocDecisionApiUrl: 'blocDecisionApiUrl',
  BlocEligibilityApiUrl: 'blocEligibilityApiUrl',
  BlocEngagementApiUrl: 'blocEngagementApiUrl',
  BlocFundingApiUrl: 'blocFundingApiUrl',
  BlocGatherApiUrl: 'blocGatherApiUrl',
  BlocInsightsUserPreferencesApiUrl: 'blocInsightsUserPreferencesApiUrl',
  BlocKycRefreshApiUrl: 'blocKycRefreshApiUrl',
  BlocMembershipsApiUrl: 'blocMembershipsApiUrl',
  BlocMessageCenterApiUrl: 'blocMessageCenterApiUrl',
  BlocOnboardingApiUrl: 'blocOnboardingApiUrl',
  BlocPlatformApplicationApiUrl: 'blocPlatformApplicationApiUrl',
  BlocProfileApiUrl: 'blocProfileApiUrl',
  BlocProvidersApiUrl: 'blocProvidersApiUrl',
  BlocRemittanceApiUrl: 'blocRemittanceApiUrl',
  BlueprintOneLoginUrl: 'blueprintOneLoginUrl',
  BlueprintUrl: 'blueprintUrl',
  DatadogApplicationId: 'datadogApplicationId',
  DatadogClientId: 'datadogClientId',
  DatadogReplaySampleRate: 'datadogReplaySampleRate',
  DatadogSessionSampleRate: 'datadogSessionSampleRate',
  FullStoryOrgId: 'fullStoryOrgId',
  GraphApiUrl: 'graphApiUrl',
  HeapKey: 'heapAppId',
  LocaleFilename: 'localeFilename',
  MycaAPIUrl: 'mycaAPIUrl',
  MycaGlobalDomain: 'mycaGlobalDomain',
  OneDataUrl: 'oneDataUrl',
  OptimizelyAppKey: 'optimizelyAppKey',
  PhantTzCommercialApiUrl: 'phantTzCommercialApiUrl',
  PZNEventsUrl: 'pznEventsUrl',
  SegmentKey: 'segmentKey',
  VirtualPaymentUrl: 'virtualPaymentUrl',
  WealthAppUrl: 'wealthAppUrl',
} as const;
